import i18next from 'i18next';

i18next.addResources('en', 'navbar', {
  HOME: 'Home',
  CLASSES: 'Classes',
  TECHNOLOGY: 'Technology',
  RESERVE: 'Reserve'
});
